import { useCallback, useMemo } from 'react';
import { useCompanySettings } from '../context/company_settings';
import { useRoomSession } from '../context/room_session';
import { useObservable } from './rxjs';
export function useSpectatorNotes() {
    const roomSession = useRoomSession();
    const [observableNote] = useObservable(roomSession.note.observableNote);
    const [loadedYn] = useObservable(roomSession.note.loadedYn);
    const settings = useCompanySettings();
    const handleSaveNote = useCallback(async (updatedNotes) => {
        await roomSession.note.saveRoomNote(updatedNotes);
    }, [roomSession]);
    return useMemo(() => {
        return {
            defaultTemplate: roomSession.note.defaultTemplate,
            onSave: handleSaveNote,
            currentlySavedMarkdown: observableNote?.text ?? '',
            onNoteUpdated: roomSession.note.onNoteUpdated,
            maxCharacters: settings?.roomNoteCharLimit ?? 0,
            currentInputText: roomSession.note.currentInputText,
            loadedYn,
        };
    }, [
        roomSession.note.defaultTemplate,
        roomSession.note.onNoteUpdated,
        roomSession.note.currentInputText,
        handleSaveNote,
        observableNote?.text,
        settings?.roomNoteCharLimit,
        loadedYn,
    ]);
}
//# sourceMappingURL=use_spectator_notes.js.map